import store from "./store";
import axios from "axios";
import utility from "./utility";
import request from "./curl";


var board_utility = {
  /*
  * unlock_card: This method checks if a selected card exists in the store and if it does than unlock that card.
  * This method only gets called on refreshing or leaving the boards route.
  * 1: Emit on socket to unlock it from all the users.
  * 2: Fire an api to unlock it in database.
  * 3: setSelectedCardToEdit value to null.
  * */
  unlock_card() {
    let edit_card = store.getters.getSelectedCardToEdit;
    if(edit_card) {

      //Clear the card interval so it doesn't keep on saving after every minute
      clearInterval(edit_card.interval);

      let api = 'board_card_edit';
      var api_url = process.env.VUE_APP_MESH_API+"/"+api;

      let form_data = new FormData();

      let card_json = JSON.stringify(edit_card.card);

      //Aes encrypt card
      let key = this.get_aes_key(edit_card.card_id, edit_card.board_id,edit_card.board_data);

      card_json = utility.aes_encrypt(key, card_json);

      form_data.append("card_json", card_json);
      form_data.append("card_id", edit_card.card_id);
      form_data.append("board_id", edit_card.board_id);
      form_data.append("user_id", edit_card.user_id);
      form_data.append("acc_id", edit_card.acc_id);
      form_data.append('lock_status', JSON.stringify(
        {
          'is_locked': false,
          'locked_by': '',
          'locked_by_id': ''
        }));

      axios({
        method: "post",
        url: api_url,
        timeout: 1000 * 60, // Wait for 60 seconds
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: 'Bearer ' + store.getters.getToken
        },
        data: form_data
      });

      //Set selected card to null
      store.commit('setSelectedCardToEdit', null);
    }
  },
  /*
   * get_aes_key
   *
   * Make a key for card encryption, Use
   * UserID: Personal Board (board_type: 1)
   * AccountID: Account Board (board_type: 2)
   * GroupID: Group Board (board_type: 3)
   *
   * */
  get_aes_key(card_id, board_id, board) {
    let key = '';

    if(board['board_type'] == 1) {
      key += board['user_id'];
    }
    else if(board['board_type'] == 2) {
      key += board['acc_id'];
    }
    else {
      key += board['group_id'];
    }

    return key += board_id+card_id;
  },
  /*
   * board_list
   * Sample Filter Data
   * All = [{"name":"user_id","value":"Qlz2YwKSc0hYZ6CxZq6rPQpRLCz1","type":-1}]
   * Group = [{"name":"group_id","value":"27a0e31b00b11d61b4eb1f0e3d4eb5c9","type":3}]
   * Personal = [{"name":"user_id","value":"Qlz2YwKSc0hYZ6CxZq6rPQpRLCz1","type":1}]
   * 
   * */
  board_list(self, selected_board_type, selectedGroup) {
    let filter = [];    
    let insert_data = new FormData();

    if(selected_board_type == 'Group') {
      filter[0] = {
        'name': 'group_id',
        'value': selectedGroup,
        'type' : 3
      };
    }
    else if(selected_board_type == 'Personal') {
      filter[0] = {
        'name': 'user_id',
        'value': self.userData.user_id,
        'type' : 1
      };
    }
    else if(selected_board_type == 'All') {
      filter[0] = {
        'name': 'user_id',
        'value': self.userData.user_id,
        'type' : -1 //All
      };
    }    

    insert_data.append("filter", JSON.stringify(filter));

    return request.curl(self, "board_list", insert_data)
    .then(response => {
      return response;
    });
  },  
  /*
   * board_and_topic_list
   * 
   * */  
  board_and_topic_list(self, selectedGroup) {
    let insert_data = new FormData();
    insert_data.append("group_id", selectedGroup);
    return request.curl(self, "board_and_topic_list", insert_data)
    .then(response => {
      return response;
    });
  },
  /**
   * mark_complete
   * 
   */
  async mark_complete(self, complete = '1', card, board_id, acc_id) {
    let form_data = new FormData();
    form_data.append("card_id", card.card_id);
    form_data.append("board_id", board_id);
    form_data.append('acc_id', acc_id);
    form_data.append("status", complete);
    let resp = null;
    await request.curl(self, "board_card_edit", form_data)
      .then(async response => {
        if (!response.resp_status) {
          return false;
        }
        else {
          if(complete == 1) {
            //marked complete
            resp = 1;
          }
          else {
            //marked incomplete
            resp = 2;
          }
        }
      });
    return resp;
  } 
}

export default board_utility;